import React from 'react';

export const BellIcon: React.FC<{ className?: string }> = ({ className = "" }) => (
  <span className={`material-symbols-outlined ${className}`}>
    notifications
  </span>
);
